
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/linktree",
      function () {
        return require("private-next-pages/linktree.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/linktree"])
      });
    }
  